import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'
import userTransformer from './transformers/user.transformer'

eventBus.$on(eventDefinitions.USER.REGISTERED, ({ user }) => {
  if (!user) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'sign_up',
    signup_user_properties: userTransformer(user),
  })
})
